export const EMPTY_STRING = '';
export const WHITE_SPACE_STRING = ' ';
export const ZERO_STRING = '0';

export const NFD = 'NFD';

// REGEXs
export const DIACRITIC_REGEX = /[\p{Diacritic}]/gu;
export const IS_VALID_PHONE_NUMBER_REGEX = /^\+?\d{4,17}$/;
export const IS_PHONE_NUMBER_REGEX = /^\+?\d+$/;
export const IS_VALID_EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
